/* eslint-disable */
import { produce } from "immer";
import {create} from "zustand";

export type BuyConfirmResponseData = {
  finalAmount: number;
  transactionId: string;
  buyGoldRate: number;
  weight: number;
  goldValue: number;
  status: string;
  startDate: string;
  startDay: string;
  gst: number;
};

export const BuyConfirmInitialData = {
  finalAmount: 0,
  transactionId: "",
  buyGoldRate: 0,
  weight: 0,
  goldValue: 0,
  status: "",
  startDate: "",
  startDay: "",
  gst:0
};
type BuyConfirm = {
  confirmData: BuyConfirmResponseData;
};

const initialState: BuyConfirm = {
  confirmData: BuyConfirmInitialData,
};

export type BuyConfirmStore = {
  updateConfirmResponse: (confirmData: BuyConfirm["confirmData"]) => void;
  resetBuyConfirmData: () => void;
};
export const useBuyConfirmStore = create<BuyConfirm & BuyConfirmStore>(
  (set) => ({
    ...initialState,
    updateConfirmResponse: (confirmData) => {
      set(
        produce((state: BuyConfirm) => {
          state.confirmData = confirmData;
        })
      );
    },
    resetBuyConfirmData: () => set(initialState),
  })
);
